import ApplicationController from './application_controller';

// Confort de saisie du formulaire de réponse au relogement : rien ici n'est
// nécessaire à la validité de la réponse. Le serveur revalide tout (unicité des
// rangs, parkings proposés, déclaration de badge) et réaffiche le formulaire avec
// l'erreur si le JavaScript est coupé.
export default class extends ApplicationController {
  static targets = ['rank', 'noneSuitable', 'hasBadge', 'badgeNumber', 'formula', 'price',
                    'customChoice', 'customParking'];

  connect() {
    this.syncNoneSuitable();
    this.syncBadgeNumber();
    this.syncCustomParking();
  }

  // Choisir soi-même un parking remplace les propositions : on neutralise les
  // classements et le refus global, que le serveur refuserait de toute façon
  // ensemble.
  customChoiceChanged() {
    if (this.hasCustomChoiceTarget && this.customChoiceTarget.checked) {
      this.rankTargets.forEach((select) => { select.value = ''; });
      if (this.hasNoneSuitableTarget) this.noneSuitableTarget.checked = false;
      this.syncNoneSuitable();
    }
    this.syncCustomParking();
  }

  syncCustomParking() {
    if (!this.hasCustomParkingTarget || !this.hasCustomChoiceTarget) return;

    const demande = this.customChoiceTarget.checked;
    this.customParkingTarget.style.display = demande ? 'block' : 'none';
    this.rankTargets.forEach((select) => { select.disabled = demande; });
  }

  // Changer de formule réaffiche les tarifs déjà calculés côté serveur : le
  // navigateur ne fait que choisir la bonne ligne, aucun calcul de prix ici.
  formulaChanged() {
    if (!this.hasFormulaTarget) return;

    const cle = this.formulaTarget.value;
    this.priceTargets.forEach((paragraphe) => {
      let tarifs = {};
      try {
        tarifs = JSON.parse(paragraphe.dataset.prices || '{}');
      } catch (e) {
        return;
      }
      paragraphe.textContent = tarifs[cle] || 'Formule indisponible sur ce parking';
    });
  }

  // Un rang ne peut servir qu'une fois : on libère celui qu'un autre parking portait.
  rankChanged(event) {
    const choisi = event.target.value;

    if (choisi !== '') {
      this.rankTargets.forEach((select) => {
        if (select !== event.target && select.value === choisi) select.value = '';
      });

      if (this.hasNoneSuitableTarget && this.noneSuitableTarget.checked) {
        this.noneSuitableTarget.checked = false;
        this.syncNoneSuitable();
      }

      if (this.hasCustomChoiceTarget && this.customChoiceTarget.checked) {
        this.customChoiceTarget.checked = false;
        this.syncCustomParking();
      }
    }
  }

  noneSuitableChanged() {
    if (this.hasNoneSuitableTarget && this.noneSuitableTarget.checked &&
        this.hasCustomChoiceTarget && this.customChoiceTarget.checked) {
      this.customChoiceTarget.checked = false;
      this.syncCustomParking();
    }
    this.syncNoneSuitable();
  }

  badgeChanged() {
    this.syncBadgeNumber();
  }

  syncNoneSuitable() {
    if (!this.hasNoneSuitableTarget) return;

    const refuse = this.noneSuitableTarget.checked;
    this.rankTargets.forEach((select) => {
      if (refuse) select.value = '';
      select.disabled = refuse;
    });
  }

  syncBadgeNumber() {
    if (!this.hasBadgeNumberTarget) return;

    const possede = this.hasBadgeTargets.some((radio) => radio.checked && radio.value === 'true');
    this.badgeNumberTarget.style.display = possede ? 'block' : 'none';
  }
}
